module.exports = __webpack_public_path__ + "img/empty_record.2be76de.png";